import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { popupOpenClose } from "../../../action/action";

const ResReservation3c = (props) => {

    const { t } = props
    let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let checkRenderEmail = props.email || localStorage.getItem("resReservationEmail") || ""
    const [email, setEmail] = useState(props.email || localStorage.getItem("resReservationEmail") || "")

    const [extraData, setExtraData] = useState({
        "createReservationBody": {
            "reservationDetails": [{
                "reservationDetailAllergies": [],
                "customerComments": null
            }]
        }
    })


    const handleCheckboxChange = (event, allergy) => {
        const { createReservationBody } = extraData;
        let updatedAllergies = [...createReservationBody.reservationDetails[0].reservationDetailAllergies];

        if (event.target.checked) {

            const payload = {
                "id": 0,
                "reservationDetailId": 0,
                allergyId: allergy.id,
                allergyComment: "",
                "isNew": true,
                "isDeleted": true
            }

            if (allergy.description == "None") {
                updatedAllergies = [payload];
            } else {
                updatedAllergies.push(payload);
            }
        } else {
            const index = updatedAllergies.findIndex((item) => item.allergyId === allergy.id);
            if (index !== -1) {
                updatedAllergies.splice(index, 1);
            }
        }

        setExtraData({
            createReservationBody: {
                reservationDetails: [
                    {
                        reservationDetailAllergies: updatedAllergies,
                        customerComments: createReservationBody.reservationDetails[0].customerComments,
                    },
                ],
            },
        });
    };


    const handleCommentChange = (event) => {
        const { createReservationBody } = extraData;
        const updatedComments = event.target.value;

        setExtraData({
            createReservationBody: {
                reservationDetails: [
                    {
                        reservationDetailAllergies: createReservationBody.reservationDetails[0].reservationDetailAllergies,
                        customerComments: updatedComments,
                    },
                ],
            },
        });
    };

    const handleAllergiesComment = (comment, allergyId) => {
        setExtraData((prevData) => {
            const updatedAllergies = prevData.createReservationBody.reservationDetails[0].reservationDetailAllergies.map((allergy) => {
              if (allergy.allergyId == allergyId) {
                return {
                  ...allergy,
                  allergyComment: comment,
                };
              } else {
                return allergy;
              }
        });  

            const updatedReservationBody = {
                ...prevData.createReservationBody,
                reservationDetails: [{
                    ...prevData.createReservationBody.reservationDetails[0],
                    reservationDetailAllergies: updatedAllergies,
                }],
            };

            return {
                ...prevData,
                createReservationBody: updatedReservationBody,
            };
        });
    };

    const handleNext = () => {

        if(props.updatingCustomerDetails){
            props.next(extraData)
        } else {
            if (!email || email == "") {
            props.popupOpenClose(true, t('resReservation.missing.missing_date'))
            return;
        }

        if(!emailRegex.test(email)){
            props.popupOpenClose(true, "Please enter a valid email");
            return;
        }

        localStorage.setItem("resReservationEmail", email)

        setExtraData((prevData) => {
            const updatedReservationDetails = [
              {
                ...prevData.createReservationBody.reservationDetails[0],
                email: email,
              },
            ];

            let updateCreateReservationBody = {
                createReservationBody: {
                    reservationDetails: updatedReservationDetails,
                  }
            }

            props.next(updateCreateReservationBody)

            return updateCreateReservationBody;
          });
        }
    }

    React.useEffect(() => {
        if (props.createReservationData.createReservationBody.reservationDetails[0]) {
            const { reservationDetailAllergies, customerComments } = props.createReservationData.createReservationBody.reservationDetails[0];

            let updatedReservationAllergies = [];
            if(reservationDetailAllergies){
                updatedReservationAllergies = reservationDetailAllergies.map((allergy) => ({
                    ...allergy,
                    "id": 0,
                    "reservationDetailId": 0,
                    "isNew": true,
                    "isDeleted": true
                }));
            }

            setExtraData(prevExtraData => ({
                ...prevExtraData,
                createReservationBody: {
                    ...prevExtraData.createReservationBody,
                    reservationDetails: [
                        {
                            ...prevExtraData.createReservationBody.reservationDetails[0],
                            customerComments: customerComments || "",
                            reservationDetailAllergies: updatedReservationAllergies
                        }
                    ]
                }
            }));
        }
    }, [])


    return (
        <>
            <section class="widgets">
                <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                    <h2>{props.subHeading}</h2>
                </div>
                <div class="form-window">
                    <div class="form-window-heading">{t('resReservation.additional_information_heading')}</div>
                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderColor: "#ccc" }}>
                        { !props.updatingCustomerDetails && checkRenderEmail == "" && <div className="form-row">
                            <label for="email">{t('resReservation.email')} <span style={{ color: "red" }}>*</span></label>
                            <input name="email" value={email} id="email" type="email" inputMode='email' autoComplete='email' onChange={(e => setEmail(e.target.value))} />
                        </div>}
                        <div class="form-row">
                            <div class="drawer open">
                                <div class="drawer-header">
                                    <div class="drawer-icons">
                                        <span class="fa fa-chevron-down"></span>
                                        <span class="fa fa-chevron-up"></span>
                                    </div>
                                    <label>{t('resReservation.select_allergies')}</label>
                                </div>
                                <div class="drawer-body">
                                    {
                                        props.allergiesList.map((allergy) => {
                                            return (
                                                <>
                                                    <label><input type="checkbox" value={allergy.id} onChange={(event) => handleCheckboxChange(event, allergy)} checked={extraData.createReservationBody.reservationDetails[0].reservationDetailAllergies.some((item) => item.allergyId === allergy.id)} class="margin-right-1" />{allergy.description}</label>
                                                    {extraData.createReservationBody.reservationDetails[0].reservationDetailAllergies.map((item) => {
                                                        if(item.allergyId === allergy.id){
                                                            return (
                                                                <div class="other-allergies" style={{ width: "90%" }} >
                                                                    <input type="text" name="Other Allergies" value={item.allergyComment} onChange={(e) => { handleAllergiesComment(e.target.value, allergy.id) }} placeholder={t('resReservation.select_allergies_placeholder')} />
                                                                </div>
                                                            )
                                                        }
                                                        else return null;
                                                    })}
                                                </>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <label for="childCounter">{t('resReservation.additional_request')}</label>
                            <textarea value={extraData.createReservationBody.reservationDetails[0].customerComments || ''} onChange={handleCommentChange} placeholder={t('resReservation.additional_request_placeholder')} rows="5"></textarea>
                        </div>
                    </div>
                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <div class="form-controls">
                            <button class="primary w-100 margin-bottom-1" onClick={() => handleNext()}>{props.updatingCustomerDetails ? t('resReservation.update_reservation') : t('resReservation.create_reservation')}</button>
                            <button class="secondary w-100" onClick={() => props.close()}>{t('resReservation.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, {popupOpenClose})(withTranslation('translations')(ResReservation3c));